import { Skeleton } from "../../components/ui/skeleton";

export default function MessagesSkeleton() {
  return (
    <div className="w-full space-y-8 pb-20 animate-in fade-in duration-500">
      {/* Header Skeleton */}
      <div className="bg-white rounded-[2.5rem] shadow-sm border border-slate-200 overflow-hidden mb-8">
        <div className="p-8 sm:p-10">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6 mb-8">
            <div className="space-y-1">
              <Skeleton className="h-8 w-48" />
              <Skeleton className="h-4 w-64" />
            </div>
            <Skeleton className="w-12 h-12 rounded-2xl" />
          </div>
          <Skeleton className="w-full h-16 rounded-[1.25rem]" />
        </div>
      </div>

      {/* Messages List Skeleton */}
      <div className="space-y-4">
        {[...Array(5)].map((_, i) => (
          <div key={i} className="bg-white rounded-[2rem] border-2 border-slate-100 p-8 flex items-center gap-6">
            <Skeleton className="w-12 h-12 rounded-full shrink-0" />
            <div className="flex-1 space-y-3">
               <div className="flex justify-between">
                 <Skeleton className="h-4 w-32" />
                 <Skeleton className="h-3 w-16" />
               </div>
               <Skeleton className="h-6 w-3/4" />
               <Skeleton className="h-4 w-full" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
